import { computed,  } from "@vue/composition-api"
import { UserState, UserGetters } from "./types";

export default function gettersFactory(state: UserState): UserGetters {    
    return {    
        isAuthenticated: computed(() => { return null != state.user })
    }
}